module.exports = __webpack_public_path__ + "img/crown3.57687060.png";